import React from "react";
import "./puja-campaign-redirect-loader.scss";

export default function RedirectLoader() {
  return (
    <div className="flex-col-center PujaCampaignRedirectLoader">
      <div className="loader"></div>

      <p className="title">Please do not close or refresh this page.</p>
    </div>
  );
}
